import React from 'react';
import PropTypes from 'prop-types';
import { PageTitle, Button } from '@cordata/buffet';
import { useParams, Link } from 'react-router-dom';
import {
  UncontrolledButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from 'reactstrap';
import { toast } from 'react-toastify';

import { Table } from '~/components/Doc';

import { AttachmentProvider, useAttachment } from '~/utils/attachment';

const ActionsCell = ({ original }) => {
  const { actions: { deleteAttachment, viewAttachment } } = useAttachment();

  const handleDelete = () =>
    deleteAttachment(original.id)
      .then(() => toast.success('Successfully deleted!'))
      .catch(() => toast.error('Oops, something went wrong.'));

  const handleVisit = () =>
    viewAttachment({ ...original.attributes });

  return (
    <UncontrolledButtonDropdown size="sm" className="w-100">
      <Button
        outline
        color="tertiary"
        icon="eye"
        onClick={handleVisit}
      >
        Visit document
      </Button>

      <DropdownToggle caret outline color="tertiary" />

      <DropdownMenu right>
        <DropdownItem
          onClick={handleDelete}
          className="text-danger"
        >
          Delete document
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledButtonDropdown>
  );
};

ActionsCell.propTypes = {
  original: PropTypes.shape().isRequired,
};

const PatientsDocsCollection = () => {
  const params = useParams();

  return (
    <AttachmentProvider>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            to={`/patients/${params.patient_id}/docs/add`}
            icon="plus"
          >
            Add Document
          </Button>
        }
      >
        Documents
      </PageTitle>

      <Table
        className="has-actions"
        params={{
          patient_uid: params.patient_id,
        }}
        columns={[{
          id: 'attachmentTitle',
          Header: 'Title',
          accessor: 'attributes.attachmentTitle',
        }, {
          id: 'attachmentDescription',
          Header: 'Description',
          accessor: 'attributes.attachmentDescription',
        }, {
          id: 'attachmentType',
          Header: 'File Type',
          accessor: 'attributes.attachmentType',
          Cell: v => <div>{v.original.attributes.attachmentType === 'link' ? 'Web Page' : 'File'}</div>,
        }, {
          id: 'createdDate',
          Header: 'Created Date',
          accessor: 'attributes.createdDate',
          cellType: 'date',
        }, {
          id: 'actions',
          Header: 'Actions',
          accessor: 'attributes',
          className: 'has-actions',
          Cell: ActionsCell,
        }]}
      />
    </AttachmentProvider>
  );
};

export default PatientsDocsCollection;
